export enum ResourceType {
  Doctor = 'doctor',
  CompanyUser = 'company_user',
  User = 'user',
  HealthUnit = 'health_unit',
  Schedule = 'schedule',
  Position = 'position',
  Station = 'station',
  Company = 'company',
  Group = 'group',
  Platform = 'platform',
  Policy = 'policy'
}

export enum PermissionType {
  Owner = 'owner',
  Admin = 'administrator',
  View = 'viewer',
  Member = 'direct_member',
  Remove = 'remove'
}

export type PermissionResponse = {
  id: number
  resource_type: ResourceType
  resource_id: number
  resource_relation: PermissionType
  subject_type: ResourceType
  subject_id: number
  subject_name: string
  subject_description?: string
}

type AuthorizationResourceObjetc = {
  objectType: 'company' | 'health_unit' | 'schedule' | 'user' | string
  objectId: string
}

type AuthorizationRelationItem = {
  readAt: {
    token: string
  }
  relationship: {
    relation: 'administrator' | 'viewer' | string
    resource: AuthorizationResourceObjetc
    subject: {
      optionalRelation: string
      object: AuthorizationResourceObjetc
    }
  }
  afterResultCursor: {
    token: string
  }
}

export type AuthorizationRelations = AuthorizationRelationItem[]

/** Uma origem que concede acesso ao recurso (direta ao usuário ou via grupo). */
export interface PermissionTreeOrigin {
  kind: 'direct' | 'group'
  relation: string
  is_inherited: boolean
  group_id?: number
  group_name?: string
}

/**
 * Nó da árvore de permissões: UM por recurso, com as origens consolidadas
 * (ordenadas pelo backend: direct primeiro, depois grupos por nome) e a
 * relation efetiva já calculada no backend.
 */
export interface PermissionTreeItem {
  resource_type: ResourceType
  resource_id: number
  resource_name: string
  /** Relation vencedora entre todas as origens, calculada no backend. */
  effective_relation: string
  origins: PermissionTreeOrigin[]
  children?: PermissionTreeItem[]
}

export interface AccessibleCompanyOption {
  id: number
  name: string
}
